"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const RoomCardAtoms_1 = require("../RoomCardAtoms");
function default_1({ start_date, end_date, room_status_cd_id, payment_approval_cd_id, isCommission, }) {
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
            position: 'absolute',
            top: '6px',
            left: '8px',
            display: 'flex',
            alignItems: 'center',
            width: 'calc(100% - 44px)',
            flexWrap: 'wrap',
            rowGap: '2px',
            columnGap: '4px',
        } }, { children: [!isCommission && ((0, jsx_runtime_1.jsx)(RoomCardAtoms_1.DayLeft, { start_date: start_date, end_date: end_date, room_status_cd_id: room_status_cd_id })), (0, jsx_runtime_1.jsx)(RoomCardAtoms_1.AllowType, { payment_approval_cd_id: payment_approval_cd_id })] })));
}
exports.default = default_1;
